import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Inclusiveness.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Inclusiveness = () => {
    


    const goals = [
        {
            goal: 'Accessibility Standards compliance',
            PreGoal:'Goal I1:',
            description: 'AI systems are designed to be inclusive in accordance with any Accessibility Standards.',
            appliesTo: 'Where Accessibility Standards apply.',
            text2: 'Designing inclusive AI systems that adhere to accessibility standards requires a multi-faceted approach, encompassing considerations throughout the entire development lifecycle:',
            requirements: [
                {
                    id: '1. Adherence to Accessibility Standards & Guidelines:',
                    s1: 'WCAG (Web Content Accessibility Guidelines): These are the internationally recognized standards for web accessibility, ensuring content is perceivable, operable, understandable, and robust for people with disabilities. AI systems interacting with web content must comply with these guidelines.',
                    s2: "EAA (European Accessibility Act): This EU legislation establishes accessibility requirements for various products and services, though it doesn't directly address AI systems yet. However, its principles can and should be applied to AI design.",
                    s3: 'Other Relevant Standards: Depending on the specific application and context, other accessibility standards may apply, such as Section 508 in the US for federal agencies.' 
                },
                {
                    id: '2. Inclusive Design Principles:',
                    s1: 'Recognize Exclusion: Identify potential barriers for users with diverse abilities, backgrounds, and contexts.',
                    s2: "Solve for One, Extend to Many: Design solutions that address specific needs but also benefit a wider range of users. Learn from Diversity: Involve people with disabilities in the design and testing process to gain valuable insights and feedback.",
                    
                },
                {
                    id: '3. Technical Implementation:',
                    s1: 'Multi-modal Interactions: Offer multiple ways for users to interact with the AI system, including voice commands, text input, and gesture recognition.',
                    s2: "Alternative Text and Descriptions: Provide descriptive text alternatives for images, videos, and other non-text content.   ",
                    s3: 'Keyboard Accessibility: Ensure that all functionalities of the AI system can be accessed and operated using a keyboard.',
                    s4: 'Clear and Simple Language: Use plain language that is easy to understand, avoiding jargon or complex terminology. Error Handling and Feedback: Provide clear and helpful error messages and feedback to guide users through any difficulties.',
                    s5: 'Customization and Personalization: Allow users to adjust settings, such as font size, colour contrast, or speech rate, to meet their individual needs and preferences.  '
                    
                },
                {
                    id: '4. Testing and Evaluation:',
                    s1: 'Accessibility Testing: Conduct thorough testing with users with disabilities to identify and address any barriers. Assistive Technology Compatibility: Ensure that the AI system is compatible with assistive technologies such as screen readers, magnifiers, and alternative input devices.',
                    s2: "Usability Testing: Evaluate the system's overall usability and ease of use for diverse users.",
                    s3: null
                    
                },
                {
                    id: '5. Ongoing Monitoring and Improvement:',
                    s1: 'Collect User Feedback: Continuously gather feedback from users with disabilities to identify areas for improvement.',
                    s2: "Stay Up-to-Date: Keep abreast of the latest developments in accessibility standards and technologies.",
                    s3: 'Iterate and Improve: Regularly update and refine the AI system to enhance its accessibility and inclusivity.'
                    
                },

            ]
        },
    ];
 



    const goal = goals[0];


    return (
        <div style={{ backgroundColor: 'rgb(240, 242, 245)', height: '100%' }}>
          <div className='dashcontent'>
            <div>
                <h2>Inclusiveness Goal</h2>
            </div>
            <h2 className="goal-title">
              <span className="goal-prefix">{goal.PreGoal}</span> <span className="Inclue-goal-name">{goal.goal}</span>
            </h2>
            <p className="applies-to">{goal.description}</p>
            <p className="applies-to"><i>Applies when:</i> {goal.appliesTo}</p>
            {goal.text2 && <p className="applies-to">{goal.text2}</p>}
    
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="Inclue-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goal.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong>
                        {requirement.s1 && requirement.s1.length > 0 && (
                            <>
                            <br/> {requirement.s1}
                            </>
                        )}
                        {requirement.s2 && requirement.s2.length > 0 && (
                            <>
                            <br/> {requirement.s2}
                            </>
                        )}
                        {requirement.s3 && requirement.s3.length > 0 && (
                            <>
                            <br/> {requirement.s3}
                            </>
                        )}
                        {requirement.s4 && requirement.s4.length > 0 && (
                            <>
                            <br/> {requirement.s4}
                            </>
                        )}
                        {requirement.s5 && requirement.s5.length > 0 && (
                            <>
                            <br/> {requirement.s5}
                            </>
                        )}
                      </td>
                    </tr>
                  ))}
                <hr className='requirement-row'/>
                <strong className="requirement-text" >Examples of Inclusive AI Design:</strong>
                <ul>
                    <li className="sub-requirement-item">AI-powered screen readers that can accurately describe images and videos for visually impaired users.   </li>
                    <li className="sub-requirement-item">Voice-activated virtual assistants that enable people with mobility limitations to interact with technology</li>
                    <li className="sub-requirement-item">AI-powered captioning and transcription services that make audio and video content accessible to people who are deaf or hard of hearing.</li>
                    <li className="sub-requirement-item">Machine learning algorithms that can identify and address biases in data to ensure fair and equitable outcomes for all users.</li>
                </ul>
                <p className="requirement-text">By incorporating accessibility into the core design of AI systems, developers can create solutions that empower and benefit all users, regardless of their abilities or backgrounds.</p>
                </tbody>
              </table>              
            </div>
          </div>
        </div>
      );
};

    

export default Inclusiveness;